import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getSession } from "../lib/session";

export default function Home() {
  const navigate = useNavigate();

  useEffect(() => {
    getSession().then((user) => {
      navigate(user ? "/dashboard" : "/login", { replace: true });
    });
  }, [navigate]);

  return (
    <div className="loading">
      <div className="spinner" />
    </div>
  );
}
